// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import React from 'react'
import DialogActions from '@mui/material/DialogActions'
import Button from '@mui/material/Button'
import { i18n } from '../../index'
import UserFormFields from './UserFormFields'
import type { User } from './userTypes'
import css from './Users.css'

type Props = {
  onCancel: (...props: any) => any
  data: User
}

function UserUpdateForm(props: Props) {
  const { onCancel, data } = props

  return (
    <form noValidate>
      <UserFormFields data={data} />
      <DialogActions className={css.userUpdateBtns}>
        <Button type='button' onClick={onCancel}>
          {i18n.t('buttons.cancel')}
        </Button>
      </DialogActions>
    </form>
  )
}

export default UserUpdateForm
